import { render, staticRenderFns } from "./AutocompleteDealItem.vue?vue&type=template&id=0a478469&scoped=true&"
import script from "./AutocompleteDealItem.vue?vue&type=script&lang=ts&"
export * from "./AutocompleteDealItem.vue?vue&type=script&lang=ts&"
import style0 from "./AutocompleteDealItem.vue?vue&type=style&index=0&id=0a478469&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a478469",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a478469')) {
      api.createRecord('0a478469', component.options)
    } else {
      api.reload('0a478469', component.options)
    }
    module.hot.accept("./AutocompleteDealItem.vue?vue&type=template&id=0a478469&scoped=true&", function () {
      api.rerender('0a478469', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "module/Deals/view/vue/components/items/AutocompleteDealItem.vue"
export default component.exports